import { Injectable, Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'sortByCategoryId'
})

@Injectable()
export class SortByCategoryId implements PipeTransform {
    transform(array: Array<any>, args: string): Array<any> {
        if (typeof args[0] === 'undefined') {
            return array;
        }
        const direction = args[0][0];
        const column = args.replace('-' , '');
        const x = array;
        const item1 = x.filter(function( obj ) {
            return obj.type === 4;
        });
        const item2 = x.filter(function( obj ) {
            return obj.type !== 4;
        });
        item2.sort((a: any, b: any) => {
          const left = Number(new Date(a[column]));
            const right = Number(new Date(b[column]));
            return (direction === '-') ? right - left : left - right;
        });
        const concateArray = item1.concat(item2);
        return concateArray;
    }
}
